/**
 * The asset picker's pure parts: what the field shows for a path, and which
 * options a search keeps. Kept apart from the component so they're tested
 * directly.
 */
import { formatBytes } from "../../assets/AssetRegistry";
import type { AssetOption } from "./WidgetEnvironment";

/** `assets/models/league_ahri.glb` → `league_ahri`: Unreal shows asset names without extensions. */
export function assetLabel(path: string): string {
  const file = path.slice(path.lastIndexOf("/") + 1);
  const dot = file.lastIndexOf(".");
  return dot > 0 ? file.slice(0, dot) : file;
}

/** `assets/models/league_ahri.glb` → `assets/models`. */
export function assetFolder(path: string): string {
  const slash = path.lastIndexOf("/");
  return slash === -1 ? "" : path.slice(0, slash);
}

/** `assets/models · 2.4 MB`: where an asset lives and what it costs to download. */
export function assetDetail(asset: { readonly path: string; readonly bytes: number }): string {
  return `${assetFolder(asset.path)} · ${formatBytes(asset.bytes)}`;
}

/** Options whose label or path contains the query, case-insensitively. */
export function filterAssetOptions(
  options: readonly AssetOption[],
  query: string,
): readonly AssetOption[] {
  const needle = query.trim().toLowerCase();
  if (needle === "") return options;
  return options.filter(
    (option) =>
      option.label.toLowerCase().includes(needle) || option.value.toLowerCase().includes(needle),
  );
}
